import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';

import { SWRConfig } from 'swr';

import store from './app/store';

import App from './App';

import i18n from './i18n/config';

import { fetcher } from './common/utils/fetcher';
import { insightsDesignEnabled } from './common/utils/insightsDesignEnabled';
import portalTheme from './theme/portalTheme';

import Coupons from './routes/coupons';
import Dashboard from './routes/dashboard';
import FeaturedProducts from './routes/featured-products';
// import Login from './routes/login';
import Login from './routes/login/index';
import QRCodes from './routes/qr-codes';
import QRCodeCreate from './routes/qr-codes/create';
import reportWebVitals from './reportWebVitals';
import Read from './components/CRUD/Read';
import BeefCutCreate from './routes/featured-products/create';
import BeefProductBrands from './routes/beef-product-brands';
import BeefProductBrandCreate from './routes/beef-product-brands/create';
import CookingMethodList from './routes/CookingMethods/CookingMethodList';
import Videos from './routes/videos';
import Retailers from './routes/retailers';
import CollectionList from './routes/Collections/CollectionList';
import AuthorList from './routes/authors/AuthorList';
import RetailersCreate from './routes/retailers/create';
import QrCodeView from './routes/qr-codes/view';

import './tailwind.css';
import './index.scss';
import RecipesMenu from './routes/recipes-menu';
import RecipeView from './routes/Recipes/RecipeView';
import BeefCutsMenu from './routes/beef-cuts-menu';
import Analytics from './routes/analytics';
import BarCodeDetailsView from './routes/barcodes/View';
import CollectionsMenu from './routes/collections-menu';
import CodesMenu from './routes/codes-menu';
import CBAMenu from './routes/cba-menu';
import CookingMethodView from './routes/CookingMethods/CookingMethodView';
import CuisineList from './routes/cuisine/CuisineList';
import CuisineView from './routes/cuisine/CuisineView';
import AuthorView from './routes/authors/AuthorView';
import ArticleList from './routes/articles/ArticleList';
import ArticleView from './routes/articles/ArticleView';
import CollectionView from './routes/Collections/CollectionView';
import SmartVideosMenu from './routes/smart-videos-menu';
import SmartVideoBatches from './routes/smart-video-batches';
import SmartVideoRenders from './routes/smart-video-renders';
import SmartVideoBatchView from './routes/smart-video-batches/view';
import SmartVideosBatchCreate from './routes/smart-video-batches/create';
import SmartVideoRenderView from './routes/smart-video-renders/view';
import SmartVideoBrands from './routes/smart-video-brands';
import SmartVideoBrandView from './routes/smart-video-brands/view';
import SmartVideoProjects from './routes/smart-video-projects';
import SmartVideoProjectView from './routes/smart-video-projects/view';
import SmartVideosProjectCreate from './routes/smart-video-projects/create';
import SmartVideosBrandCreate from './routes/smart-video-brands/create';
import SmartVideosTemplateCreate from './routes/smart-video-template/create';
import BarcodeCreate from './routes/barcodes/create';
import SettingsPage from './routes/SettingsPage';
import BarcodesList from './routes/barcodes/BarcodesList';
import BeefCutView from './routes/beef-cuts/BeefCutView';
import BeefCutsList from './routes/beef-cuts/BeefCutsList';
import Insights from './routes/Insights';
import RecipeList from './routes/Recipes/RecipeList';
import PosterList from './routes/Posters/PosterList';
import BeefMerchandisingPosterDetail from './routes/Posters/BeefMerchandisingPosterDetail';
i18n.changeLanguage('en');

const root = ReactDOM.createRoot(document.getElementById('root'));

// TODO extract to own file
root.render(
  <Provider  store={store}>
    <ThemeProvider theme={portalTheme}>
    <BrowserRouter>
      <SWRConfig
        value={{
          fetcher: fetcher
        }}
      >
        <Routes>
          <Route path='/' element={<App />}>
            <Route
              index
              element={<Dashboard />}
            />

            <Route path='recipes-menu' element={<RecipesMenu />} />
            <Route path='beef-cuts-menu' element={<BeefCutsMenu />} />
            <Route path='collections-menu' element={<CollectionsMenu />} />
            <Route path='codes-menu' element={<CodesMenu />} />
            <Route path='cba-menu' element={<CBAMenu />} />

            <Route path='smart-videos'>
              <Route
                index
                element={<SmartVideosMenu />}
              />

              <Route
                path='templates'
              >
                <Route
                  index
                  element={<SmartVideoBatches />}
                />

                <Route
                  path={':id'}
                  element={<SmartVideoBatchView />}
                />

                <Route
                  path={'edit/:id'}
                  element={<SmartVideosTemplateCreate />}
                />

                <Route
                  path={'create'}
                  element={<SmartVideosTemplateCreate />}
                />
              </Route>

              <Route
                path='batches'
              >
                <Route
                  index
                  element={<SmartVideoBatches />}
                />

                <Route
                  path={':id'}
                  element={<SmartVideoBatchView />}
                />

                <Route
                  path={'edit/:id'}
                  element={<SmartVideosBatchCreate />}
                />

                <Route
                  path={'create'}
                  element={<SmartVideosBatchCreate />}
                />
              </Route>

              <Route
                path='renders'
              >
                <Route
                  index
                  element={<SmartVideoRenders />}
                />

                <Route
                  path={':id'}
                  element={<SmartVideoRenderView />}
                />

                <Route
                  path={'create'}
                  element={<SmartVideosBatchCreate />}
                />
              </Route>

              <Route
                path='brands'
              >
                <Route
                  index
                  element={<SmartVideoBrands />}
                />

                <Route
                  path={':id'}
                  element={<SmartVideoBrandView />}
                />

                <Route
                  path={'edit/:id'}
                  element={<SmartVideosBrandCreate />}
                />

                <Route
                  path={'create'}
                  element={<SmartVideosBatchCreate />}
                />
              </Route>

              <Route
                path='projects'
              >
                <Route
                  index
                  element={<SmartVideoProjects />}
                />

                <Route
                  path={':id'}
                  element={<SmartVideoProjectView />}
                />

                <Route
                  path={'edit/:id'}
                  element={<SmartVideosProjectCreate />}
                />

                <Route
                  path={'create'}
                  element={<SmartVideosProjectCreate />}
                />
              </Route>
            </Route>

            <Route path='coupons'>
              <Route
                index
                element={
                  <Read
                    title={'Coupons'}
                  >
                    <Coupons />
                  </Read>
                }
              />
            </Route>
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='featured-products' element={<FeaturedProducts />} />
            <Route path='beef-product-brands'>
              <Route
                index
                element={<BeefProductBrands />}
              />
              <Route path={'create'} element={<BeefProductBrandCreate />} />
              <Route path={':beefProductBrandId'} element={<BeefProductBrandCreate />} />
            </Route>
            <Route path='beef-product-overrides'>
              <Route
                index
                element={<BeefProductBrands />}
              />
              <Route path={'create'} element={<BeefProductBrandCreate />} />
              <Route path={':beefProductBrandId'} element={<BeefProductBrandCreate />} />
            </Route>
            <Route path='analytics'>
              <Route
                index
                element={<Analytics />}
              />
            </Route>
            <Route path='beef-cuts'>
              <Route
                index
                element={<BeefCutsList />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':beefCutId'} element={<BeefCutView />} />
            </Route>
            <Route path='videos'>
              <Route
                index
                element={<Videos />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':beefCutId'} element={<BeefCutView />} />
            </Route>
            <Route path='cooking-methods'>
              <Route
                index
                element={<CookingMethodList />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':cookingMethodId'} element={<CookingMethodView />} />
            </Route>
            <Route path='cuisine'>
              <Route
                index
                element={<CuisineList />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':id'} element={<CuisineView />} />
            </Route>
            <Route path='collections'>
              <Route
                index
                element={<CollectionList />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':id'} element={<CollectionView />} />
            </Route>
            <Route path='articles'>
              <Route
                index
                element={<ArticleList />}
              />
              <Route path={':id'} element={<ArticleView />} />
            </Route>
            <Route path='authors'>
              <Route
                index
                element={<AuthorList />}
              />
              <Route path={'create'} element={<BeefCutCreate />} />
              <Route path={':id'} element={<AuthorView />} />
            </Route>
            <Route path='login' element={<Login />} />
            <Route path='profile' element={<SettingsPage />} />
            <Route path='qr-codes'>
              <Route
                index
                element={<QRCodes />}
              />
              <Route path='create' element={<QRCodeCreate />} />
              <Route path=":qrCodeId" element={<QrCodeView />} />
            </Route>
            <Route path='recipes'>
              <Route
                index
                element={<RecipeList />}
              />
              <Route path=":recipeId" element={<RecipeView />} />
            </Route>
            <Route path='insights'>
              <Route
                index
                element={<Insights />}
              />
              <Route path=":slug" element={<Insights />} />
            </Route>
            <Route path='barcodes'>
              <Route
                index
                element={<BarcodesList />}
              />
              <Route path='create' element={<BarcodeCreate />} />
              <Route path=":barcodeId" element={<BarCodeDetailsView />} />
            </Route>
            <Route path='retailers' element={<Retailers />} />
            <Route path='create' element={<RetailersCreate />} />
            <Route path="posters" element={<PosterList />} />
            <Route
              path="posters/beef-merchandising"
              element={<BeefMerchandisingPosterDetail />}
            />
          </Route>
        </Routes>
      </SWRConfig>
    </BrowserRouter>
    </ThemeProvider>
  </Provider>
);

if (insightsDesignEnabled()) {
  document.body.classList.add('insights-design-enabled');
}

reportWebVitals();
